export default "__VITE_ASSET__FP_7UKuD__"